module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_114_20.9e88b183.pdf";